import { Container } from 'inversify';
import 'reflect-metadata';
import localforage from 'localforage';

import store from './store';
import TwilioController from './controllers/TwilioController';
import ReservationController from './controllers/ReservationController';
import ApiFactory from './services/ApiFactory';
import MojitoService from './services/MojitoService';
import ReduxAuthService from './services/ReduxAuthService';
import SessionService from './services/SessionService';
import EventFactory from './services/EventFactory';
import StateFactory from './services/StateFactory';
import StateInstance from './services/StateInstance';
import GEMSService from './services/GEMSService';
import Features from './services/Features';
import TranslationService from './i18n/TranslationService';

// TODO: make it test friendly
const getCacheInstance = name =>
  localforage.createInstance({ name, driver: localforage.LOCALSTORAGE });

const container = new Container({
  defaultScope: 'Singleton',
});

// Controllers
container.bind('TwilioController').to(TwilioController);
container.bind('ReservationController').to(ReservationController);

container.bind('Configuration').toConstantValue(window.settings);
container.bind('Store').toConstantValue(store);
container.bind('SessionCache').toConstantValue(getCacheInstance('session'));
container.bind('GlobalCache').toConstantValue(getCacheInstance('global'));

// Instances
container.bind('StateInstance').to(StateInstance).inTransientScope();

// Factory
container.bind('ApiFactory').toFactory(ApiFactory);
container.bind('EventFactory').toFactory(EventFactory);

// Services
container.bind('StateFactory').toFactory(StateFactory);
container.bind('MojitoService').to(MojitoService);
container.bind('GEMSService').to(GEMSService);
container.bind('AuthService').to(ReduxAuthService);
container.bind('SessionService').to(SessionService);
container.bind('Features').to(Features);
container.bind('TranslationService').to(TranslationService);

export default container;



// WEBPACK FOOTER //
// ./src/container.js